import DOMPurify from "dompurify";

/**
 * Allowlist for Salesforce lightning-input-rich-text HTML on work-item
 * instructions and thread bodies. Strips scripts, inline handlers, styles,
 * and images; hardens links for new-tab opens.
 */
const ALLOWED_TAGS = [
  "p",
  "br",
  "b",
  "strong",
  "i",
  "em",
  "u",
  "s",
  "ul",
  "ol",
  "li",
  "a",
  "h1",
  "h2",
  "h3",
  "blockquote",
  "span",
  "div",
];

const ALLOWED_ATTR = ["href"];

export const sanitizeRichHtml = (html) => {
  if (html == null) return "";

  const clean = DOMPurify.sanitize(String(html), {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    FORBID_TAGS: ["script", "iframe", "img", "style"],
    FORBID_ATTR: [
      "style",
      "class",
      "onclick",
      "onerror",
      "onload",
      "onmouseover",
    ],
  });

  if (!clean) return "";

  const doc = new DOMParser().parseFromString(clean, "text/html");
  doc.body.querySelectorAll("a[href]").forEach((anchor) => {
    anchor.setAttribute("target", "_blank");
    anchor.setAttribute("rel", "noopener noreferrer");
  });
  doc.body.querySelectorAll("span, div").forEach((el) => {
    [...el.attributes].forEach(({ name }) => el.removeAttribute(name));
  });

  return doc.body.innerHTML;
};
